<template>
  <div class="container-page">
    <div class="container-header">
      <span class="body-bold-xlarge" v-if="!isMobileBreakpoint">{{
        $t('message.memberGetMember.header.title', {
          price: userPlan.currency != 'brl' ? '$30' : 'R$ 150',
        })
      }}</span>
    </div>
    <div class="container-banner my-0">
      <div v-if="!isMobileBreakpoint" class="container-banner-img">
        <img :src="imgBanner" />
      </div>
      <div class="container-banner-text">
        <span class="body-bold-xlarge">
          {{
            $t('message.memberGetMember.banner.title', {
              price: userPlan.currency != 'brl' ? '$30' : 'R$ 150',
              gift: userPlan.currency != 'brl' ? '$40' : 'R$ 180',
            })
          }}
        </span>
        <span class="body-regular-base text-regular-base neutral-20-dark--text">
          {{
            $t('message.memberGetMember.banner.subtitle', {
              price: userPlan.currency != 'brl' ? '$30' : 'R$ 150',
            })
          }}
        </span>
        <base-btn type="neutral" size="small" @click="openFaqModal">{{
          $t('message.memberGetMember.banner.cta')
        }}</base-btn>
      </div>
    </div>
    <div class="container-budget mb-0 mt-8">
      <div class="container-budget-child">
        <span class="body-label-caption neutral-40-light--text">{{
          $t('message.memberGetMember.budget.estimated.label')
        }}</span>
        <div v-if="loading">
          <v-skeleton-loader
            class="rounded-1"
            type="chip"
            height="18"
            width="115"
            tile
          ></v-skeleton-loader>
          <v-skeleton-loader
            class="rounded-1 mt-3"
            type="chip"
            height="29"
            width="65"
            tile
          ></v-skeleton-loader>
          <v-skeleton-loader
            class="rounded mt-3"
            type="chip"
            height="18"
            width="162"
            tile
          ></v-skeleton-loader>
        </div>
        <span
          v-if="!loading"
          class="body-bold-xlarge"
          :class="{
            'opacity-value': estimatedValue == 0 && totalReceived == 0,
          }"
          >{{
            $t('message.memberGetMember.budget.estimated.text', {
              estimatedValue:
                userPlan.currency != 'brl'
                  ? `$${estimatedValue}`
                  : `R$ ${estimatedValue}`,
            })
          }}</span
        >

        <span class="body-bold-smaller" v-if="pendingReferrals && !loading"
          >{{
            $t('message.memberGetMember.budget.estimated.trial', {
              trialCount: pendingReferrals,
            })
          }}
        </span>
        <span
          class="body-bold-smaller"
          v-else-if="totalReceived != 0 && !loading"
          >{{ $t('message.memberGetMember.budget.estimated.withoutTrial') }}
        </span>
      </div>
      <div class="container-budget-child">
        <span class="body-label-caption neutral-40-light--text">{{
          $t('message.memberGetMember.budget.totalReceived.label')
        }}</span>
        <div v-if="loading">
          <v-skeleton-loader
            class="rounded-1"
            type="chip"
            height="18"
            width="115"
            tile
          ></v-skeleton-loader>
          <v-skeleton-loader
            class="rounded-1 mt-3"
            type="chip"
            height="29"
            width="65"
            tile
          ></v-skeleton-loader>
          <v-skeleton-loader
            class="rounded mt-3"
            type="chip"
            height="18"
            width="162"
            tile
          ></v-skeleton-loader>
        </div>
        <span
          class="body-bold-xlarge feedback-success--text"
          :class="{
            'opacity-value': estimatedValue == 0 && totalReceived == 0,
          }"
          v-if="!loading"
        >
          {{
            $t('message.memberGetMember.budget.totalReceived.text', {
              totalReceived:
                userPlan.currency != 'brl'
                  ? `$${totalReceived}`
                  : `R$ ${totalReceived}`,
            })
          }}
        </span>
        <span class="body-bold-smaller" v-if="currentBalance != 0 && !loading"
          >{{
            $t('message.memberGetMember.budget.totalReceived.currentBalance')
          }}
          <br v-if="isMobileBreakpoint" />
          {{ userPlan.currency != 'brl'
                ? `$ ${currentBalance}`
                : `R$ ${currentBalance}`, }}</span
        >
      </div>
    </div>
    <div
      class="container-common mb-0 mt-8"
      :class="{ 'container-common-mobile': isMobileBreakpoint }"
    >
      <div class="d-grid">
        <div>
          <span class="body-bold-base">{{
            $t('message.memberGetMember.share.title')
          }}</span>
        </div>
        <div>
          <v-skeleton-loader
            v-if="loading"
            class="rounded-1 mt-3"
            type="chip"
            height="18"
            :width="!isMobileBreakpoint ? 325 : '70vw'"
            tile
          ></v-skeleton-loader>
          <span
            v-if="!loading"
            class="body-regular-small neutral-70--text"
            style="word-break: break-all; cursor: pointer"
            @click="copyToClipboard"
            >{{ shareUrl }}</span
          >
          <v-icon
            v-if="!loading"
            size="14"
            class="ml-2 neutral-70--text"
            @click="copyToClipboard"
            >panda-copy</v-icon
          >
        </div>
      </div>
      <div
        class="d-grid-custom ga-4"
        style="gap: 16px"
        :class="{ 'd-flex': !isMobileBreakpoint && !isTabletBreakpoint }"
      >
        <div class="d-flex ga-4" style="gap: 16px" v-if="loading">
          <v-skeleton-loader
            class="rounded-1"
            type="chip"
            height="40"
            width="104"
            tile
          ></v-skeleton-loader>
          <v-skeleton-loader
            class="rounded-1"
            type="chip"
            height="40"
            width="40"
            tile
          ></v-skeleton-loader>
          <v-skeleton-loader
            class="rounded-1"
            type="chip"
            height="40"
            width="40"
            tile
          ></v-skeleton-loader>
          <v-skeleton-loader
            class="rounded-1"
            type="chip"
            height="40"
            width="40"
            tile
          ></v-skeleton-loader>
        </div>
        <base-btn type="secondary" v-if="!loading" @click="copyToClipboard">
          <v-icon size="20" class="mr-2">panda-copy</v-icon
          >{{ $t('message.memberGetMember.share.copy') }}
        </base-btn>

        <div class="d-flex" style="gap: 16px" v-if="!loading">
          <base-btn class="btn-social" type="tertiary">
            <a
              class="d-flex align-center"
              :href="
                $t('message.memberGetMember.share.socialLinkFacebook', {
                  referralLink: encodeURIComponent(shareUrl),
                  encodedQuote: encodeURIComponent(msgFacebook),
                })
              "
              target="_blank"
              rel="noopener"
            >
              <simple-svg
                width="20px"
                height="20px"
                :src="require('@/assets/facebook.svg')"
              />
            </a>
          </base-btn>
          <base-btn class="btn-social" type="tertiary">
            <a
              class="d-flex align-center"
              @click="openInstaModal"
              target="_blank"
              rel="noopener"
            >
              <simple-svg
                width="20px"
                height="20px"
                :src="require('@/assets/instagram.svg')"
              />
            </a>
          </base-btn>
          <base-btn class="btn-social" type="tertiary">
            <a
              class="d-flex align-center"
              :href="
                $t('message.memberGetMember.share.socialLinkWhatsapp', {
                  referralLink: encodeURIComponent(shareUrl),
                })
              "
              target="_blank"
              rel="noopener"
            >
              <simple-svg
                width="20px"
                height="20px"
                :src="require('@/assets/whatsapp_icon.svg')"
              />
            </a>
          </base-btn>
        </div>
      </div>
    </div>

    <div
      class="container-common mb-0 mt-8"
      :class="{ 'container-common-mobile': isMobileBreakpoint }"
    >
      <div class="">
        <span class="body-bold-base">{{
          $t('message.memberGetMember.email.title')
        }}</span>
      </div>
      <div
        :class="{ 'd-flex': !isMobileBreakpoint }"
        class="d-grid-custom"
        style="gap: 16px; min-width: 290px"
        :style="{ height: !isMobileBreakpoint ? '40px' : 'auto' }"
      >
        <v-input
          v-if="!isMobileBreakpoint"
          style="width: 600px"
          :messages="messagesEmail"
          :error="invalidEmail"
          @blur="
            invalidEmail = inputEmail.length && !validEmail()
            messagesEmail =
              !inputEmail.length || validEmail()
                ? ''
                : $t('message.memberGetMember.email.invalidEmail')
          "
          :placeholder="$t('message.memberGetMember.email.placeholder')"
          v-model="inputEmail"
        ></v-input>
        <v-textarea
          v-if="isMobileBreakpoint"
          :placeholder="$t('message.memberGetMember.email.placeholder')"
          v-model="inputEmail"
          :messages="messagesEmail"
          :error="invalidEmail"
          :rules="rules"
        ></v-textarea>
        <base-btn
          @click="sendEmail"
          :loading="loadingEmail"
          style="min-width: 106px"
        >
          <div v-if="!successEmail" style="display: flex; align-items: center">
            {{ $t('message.memberGetMember.email.send') }}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              style="margin-left: 10px"
            >
              <g clip-path="url(#clip0_2321_171)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M17.5071 0.902408C17.7274 0.82462 17.9652 0.810302 18.1934 0.861182C18.4245 0.912717 18.6362 1.02901 18.8036 1.19644C18.971 1.36387 19.0873 1.57553 19.1389 1.80664C19.1898 2.03485 19.1754 2.2727 19.0976 2.49305L13.6826 18.3215C13.5999 18.5627 13.4451 18.7735 13.2395 18.9244C13.0339 19.0752 12.787 19.1596 12.532 19.1661C12.2771 19.1727 12.0262 19.101 11.8131 18.9609C11.6 18.8207 11.4349 18.6188 11.3399 18.382L8.69026 11.7728C8.69023 11.7728 8.69029 11.7729 8.69026 11.7728C8.64825 11.6685 8.58549 11.5736 8.50591 11.4942C8.42628 11.4147 8.33138 11.3522 8.22693 11.3103L1.61817 8.66017C1.38146 8.5652 1.17931 8.40002 1.03915 8.18693C0.898996 7.97384 0.827375 7.72298 0.833906 7.46801C0.840437 7.21304 0.924806 6.96617 1.07569 6.76054C1.22657 6.5549 1.43675 6.40035 1.67801 6.31761L17.5071 0.902408ZM17.2473 2.75279L3.28021 7.53099L8.84641 9.76308C9.15977 9.88854 9.44447 10.0762 9.68336 10.3146C9.92226 10.5531 10.1104 10.8375 10.2364 11.1506L12.4691 16.7197L17.2473 2.75279Z"
                  fill="white"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M18.8009 1.19998C19.1264 1.52544 19.1263 2.05307 18.8009 2.3785L9.68423 11.4943C9.35878 11.8198 8.83134 11.8196 8.50591 11.4942C8.18049 11.1687 8.18032 10.6412 8.50577 10.3158L17.6224 1.19993C17.9479 0.874509 18.4755 0.874533 18.8009 1.19998Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_2321_171">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div v-else style="display: flex; align-items: center">
            <v-icon size="20" class="mx-4">mdi-check</v-icon>
          </div>
        </base-btn>
      </div>
    </div>
    <div
      class="container-footer mb-0 mt-8"
      :class="{
        'container-footer-mobile': isMobileBreakpoint || isTabletBreakpoint,
      }"
    >
      <div
        class="d-grid"
        :class="{ 'w-full': isMobileBreakpoint }"
        style="padding: 24px; width: 50%"
      >
        <v-icon class="mb-4">panda-info-outline</v-icon>
        <span class="body-bold-base">{{
          $t('message.memberGetMember.footer.rules.title')
        }}</span>
        <span class="body-regular-small">{{
          $t('message.memberGetMember.footer.rules.subtitle')
        }}</span>
        <base-btn type="tertiary" class="mt-4" @click="openFaqModal">
          {{ $t('message.memberGetMember.footer.rules.cta') }}
        </base-btn>
      </div>
      <v-divider
        :vertical="!isMobileBreakpoint"
        class="mx-8"
        :class="{ 'my-8 mx-0': isMobileBreakpoint }"
      ></v-divider>
      <div
        class="d-grid"
        :class="{ 'w-full': isMobileBreakpoint }"
        style="padding: 24px; width: 50%"
      >
        <v-icon class="mb-4">panda-affiliates</v-icon>
        <span class="body-bold-base">{{
          $t('message.memberGetMember.footer.history.title')
        }}</span>
        <span class="body-regular-small">{{
          $t('message.memberGetMember.footer.history.subtitle')
        }}</span>
        <base-btn type="tertiary" class="mt-4" @click="openHistoryModal">
          {{ $t('message.memberGetMember.footer.history.cta') }}
        </base-btn>
      </div>
      <v-divider
        :vertical="!isMobileBreakpoint"
        class="mx-8"
        :class="{ 'my-8 mx-0': isMobileBreakpoint }"
      ></v-divider>
      <div
        class="d-grid"
        :class="{ 'w-full': isMobileBreakpoint }"
        style="padding: 24px; width: 50%"
      >
        <v-img
          class="mb-2"
          src="@/assets/pandaMainLogo.svg"
          :max-width="32"
        ></v-img>
        <span class="body-bold-base">{{
          $t('message.memberGetMember.footer.partners.title')
        }}</span>
        <span class="body-regular-small">{{
          $t('message.memberGetMember.footer.partners.subtitle')
        }}</span>
        <base-btn type="tertiary" class="mt-4" @click="openArticle">
          {{ $t('message.memberGetMember.footer.partners.cta') }}
          <v-icon size="20" class="ml-2">mdi-open-in-new</v-icon>
        </base-btn>
      </div>
    </div>
    <history-modal
      :transactions="transactions"
      :currencySymbol="currencySymbol"
      :isLoading="loading"
    ></history-modal>
    <faq-modal></faq-modal>
    <instagram-modal :invite="shareUrl" :currency="currency"></instagram-modal>
  </div>
</template>
<script>
// external imports
import { mask } from 'vue-the-mask'
import { mapState, mapMutations } from 'vuex'
import memberGetMemberApi from '@/services/memberGetMemberApi'
import imgBanner from '@/assets/memberGetMember/img-banner.png'
// internal imports
import linkHelper from '@/utils/linkHelper.mixin.js'
// components
import i18n from '@/translations/lang'
//mixins
import logoBonificationMixin from '@/utils/logoBonification.mixin.js'
import BaseBtn from '../../components/BaseBtn.vue'
import HistoryModal from './Modals/HistoryModal.vue'
import FaqModal from './Modals/FaqModal.vue'
import InstagramModal from './Modals/InstagramModal.vue'

import img_pt from './Modals/Assets/img-pt.png'
import img_es from './Modals/Assets/img-es.png'
import img_en from './Modals/Assets/img-pt.png'
import img_pt_us from './Modals/Assets/img-pt.png'
import img_es_us from './Modals/Assets/img-pt.png'
import img_en_us from './Modals/Assets/img-pt.png'
export default {
  name: 'MemberGetMember',
  directives: { mask },
  components: {
    BaseBtn,
    HistoryModal,
    FaqModal,
    InstagramModal,
  },
  mixins: [linkHelper, logoBonificationMixin],
  data: () => ({
    imgBanner,
    shareUrl: 'http://www.pandavideo.com/invite/4103-4930-1023',
    totalReceived: 0,
    estimatedValue: 0,
    pendingReferrals: 0,
    confirmedReferrals: 0,
    transactions: [],
    inputEmail: '',
    currency: 'brl',
    currencySymbol: 'R$',
    currentBalance: 0,
    loading: true,
    messagesEmail: '',
    loadingEmail: false,
    successEmail: false,
    invalidEmail: false,
    rules: {
      minLength: (v) => (v && v.length > 2) || i18n.t('message.minimumLength'),
      validEmail: (v) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return (
          regex.test(v) || i18n.t('message.memberGetMember.email.invalidEmail')
        )
      },
    },
  }),
  computed: {
    ...mapState({
      userPlan: (state) => state.user.userPlanInfo,
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
      isTabletBreakpoint: (state) => state.user.isTabletBreakpoint,
      isPandaBrandingBonusEnabled: (state) =>
        state.user.isPandaBrandingBonusEnabled,
    }),
    langCurrency() {
      return `${i18n.language}-${this.currency || this.userPlan?.currency}`
    },
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    openHistoryModal() {
      this.$root.$emit('openHistoryMemberGetMember')
    },
    openFaqModal() {
      this.$root.$emit('openFaqMemberGetMember')
    },
    setMsgFacebook() {
      if (i18n.language == 'pt-br') {
        return (this.msgFacebook = `Oi! Eu gostaria de recomendar o Panda Video 🐼, uma plataforma completa com inteligência artificial para hospedar aulas de cursos, VSLs e Lives: ${this.shareUrl}`)
      } else if (i18n.language == 'es') {
        return (this.msgFacebook = `¡Hola! Me gustaría recomendar Panda Video 🐼, una plataforma completa con inteligencia artificial para alojar lecciones de cursos, VSLs y Lives: ${this.shareUrl}`)
      }
      this.msgFacebook = `Hi! I'd like to recommend Panda Video 🐼, a complete AI-powered platform for hosting course lessons, VSLs, and Lives: ${this.shareUrl}`
    },
    async openInstaModal() {
      if (!this.isMobileBreakpoint && !this.isTabletBreakpoint) {
        this.$root.$emit('openInstaMemberGetMember')
        return
      }

      let imagePublicUrl

      const map = {
        'pt-br-brl': img_pt,
        'pt-br-usd': img_pt_us,
        'es-brl': img_es,
        'es-usd': img_es_us,
        'en-brl': img_en,
        'en-usd': img_en_us,
      }

      imagePublicUrl = map[this.langCurrency.toLowerCase()] || img_pt

      try {
        const response = await fetch(imagePublicUrl)
        const blob = await response.blob()
        const file = new File([blob], 'imagem-instagram.png', {
          type: blob.type,
        })

        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          await navigator.share({
            title: i18n.t('message.memberGetMember.instaModal.title'),
            text: i18n.t('message.memberGetMember.banner.title', {
              price: this.userPlan.currency != 'brl' ? '$30' : 'R$ 150',
              gift: this.userPlan.currency != 'brl' ? '$40' : 'R$ 180',
            }),
            files: [file],
          })
        } else {
          window.open(imagePublicUrl, '_blank')
        }
      } catch (error) {
        console.log(error)
      }
    },
    validEmail() {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      const isValid = regex.test(this.inputEmail)
      if (!isValid) {
        this.messagesEmail = i18n.t(
          'message.memberGetMember.email.invalidEmail'
        )
        this.invalidEmail = true
      } else {
        this.messagesEmail = ''
        this.invalidEmail = false
      }
      return isValid
    },
    async sendEmail() {
      if (!this.validEmail() || this.successEmail) return
      this.loadingEmail = true
      const lang = i18n.language == 'pt-BR' ? 'pt' : i18n.language
      const body = {
        emails: [this.inputEmail],
        language: lang,
      }
      await memberGetMemberApi
        .sendInviteEmail(body)
        .then((res) => {
          this.loadingEmail = false
          this.successEmail = true
          this.inputEmail = ''
          if (res.data?.results[0]?.status !== 'success') {
            this.UPDATE_GLOBAL_SNACKBAR({
              open: true,
              text: i18n.t(
                'message.memberGetMember.email.alreadySendAndReceived'
              ),
            })
          } else {
            this.UPDATE_GLOBAL_SNACKBAR({
              open: true,
              type: 'success',
              text: i18n.t('message.memberGetMember.email.success'),
            })
          }
          setTimeout(() => {
            this.successEmail = false
          }, 800)
        })
        .catch((err) => {
          console.log('Erro ao enviar o email:', err)
        })
    },
    openArticle() {
      const links = {
        brl: 'https://www.pandavideo.com.br/partners',
        usd: 'https://www.pandavideo.com/partners',
      }
      window.open(links[this.userPlan.currency], '_blank')
    },
    copyToClipboard() {
      navigator.clipboard
        .writeText(this.shareUrl)
        .then(() => {
          this.UPDATE_GLOBAL_SNACKBAR({
            open: true,
            type: 'success',
            text: i18n.t('message.memberGetMember.share.toast'),
          })
        })
        .catch((err) => {
          console.error('Erro ao copiar:', err)
        })
    },
    async withRetry(fn, retries = 3, delay = 1000) {
      for (let attempt = 1; attempt <= retries; attempt++) {
        try {
          return await fn()
        } catch (error) {
          if (attempt === retries) throw error
          await new Promise((resolve) => setTimeout(resolve, delay))
        }
      }
    },
  },
  created() {
    this.currencySymbol = 'R$'
  },
  async mounted() {
    this.loading = true
    this.setMsgFacebook()
    const { data } = await this.withRetry(() =>
      memberGetMemberApi.getMemberReferrals()
    )
    const transactions = await this.withRetry(() =>
      memberGetMemberApi.getMemberTransactions()
    )

    this.pendingReferrals = transactions.data?.pending_referrals?.length || 0
    const limitedReachedReferrals =
      transactions.data?.limit_reached_referrals?.map((row) => {
        return {
          ...row,
          limit_reached: true,
        }
      }) || []
    this.transactions = [
      ...transactions.data.pending_referrals,
      ...transactions.data.confirmed_referrals,
      ...limitedReachedReferrals,
    ]
    this.$root.$on('updateNavigationItems', () => {
      this.currency = this.userPlan.currency
    })

    this.totalReceived = ` ${data.total_received}`
    this.estimatedValue = ` ${data.estimated_value}`
    this.currentBalance = ` ${data.current_balance}`
    this.shareUrl = `${data.referral_link}`
    this.loading = false
    this.$root.$on('changeLanguage', this.setMsgFacebook())
  },
}
</script>
<style lang="scss">
.base-button {
  span {
    display: flex;
    justify-content: center;
  }
}
</style>
<style lang="scss" scoped>
.neutral-70--text {
  color: varFigma(neutral-70);
}
.container-page {
  height: 100%;
  background-color: #f7f7f8;
  padding-bottom: 64px;
}
.bg-dark {
  .container-page {
    background-color: var(--v-neutral-darken3);
  }
}
.btn-social {
  display: flex;
  cursor: pointer;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  border-radius: var(--spacing-03, 8px);
  background: varFigma(neutral-95-lightest);
}
.feedback-success--text {
  color: varFigma(feedback-success);
}
.d-grid {
  display: grid;
  justify-items: start;
}
.w-full {
  width: 100% !important;
}
.container-header {
  display: flex;
  padding: $spacing-07 $spacing-10;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
}
.container-banner {
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 24px;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 16px;
  background: varFigma(neutral-95-lightest);
  margin: $spacing-07;
}
.text-regular-base {
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.container-banner-text {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 8px;
}
.container-budget {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  margin: $spacing-07;
}
.container-budget-child {
  display: flex;
  padding: 24px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: var(--spacing-03, 8px);
  background: varFigma(neutral-100-white);
}
.container-common {
  display: flex;
  height: 120px;
  padding: 40px 24px;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  background: varFigma(neutral-100-white);
  margin: $spacing-07;
  justify-content: space-between;
}
.container-common-mobile {
  display: grid !important;
  height: auto;
  padding: 24px;
  justify-content: center;
}
.d-grid-custom {
  display: grid;
}
.container-footer {
  display: flex;
  margin: $spacing-07;
}
.container-footer-mobile {
  display: grid !important;
  margin: $spacing-07;
}
.opacity-value {
  opacity: 0.2;
}
.hidden {
  visibility: hidden;
}
.rounded-1 {
  border-radius: 8px;
}
::v-deep .v-skeleton-loader__chip {
  width: inherit !important;
  height: inherit !important;
}
</style>
